export { GoogleTagManagerInitiator } from "./GoogleTagManagerInitiator";
